// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

// External
import { NgxPermissionsService } from 'ngx-permissions';
import { Subscription } from 'rxjs';

// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from './@metronic/core/_base/layout';
import { locale as chLang } from './i18n/ch';
import { locale as deLang } from './i18n/de';

// language list
import { locale as enLang } from './i18n/en';
import { locale as esLang } from './i18n/es';
import { locale as frLang } from './i18n/fr';
import { locale as jpLang } from './i18n/jp';

// Utils
import { DateUtil } from './core/utils/date-util';

// Service
import { TokenStorageService } from './state/core/services/token-storage/token-storage.service';
import { AuthStoreService } from './state/modules/auth/auth-store.service';

// Constant
import { getTimeZones, rawTimeZones, timeZonesNames } from '@vvo/tzdb';
import { AUTH_METHOD_CONSTANTS } from './constants/ngrx-store/auth';

@Component({
  standalone: false,
  // tslint:disable-next-line:component-selector
  selector: 'body[kt-root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  // Public properties
  title = 'Metronic';
  loader: boolean;
  initialURL = '';
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  // temp permissions

  constructor(
    private readonly router: Router,
    private readonly translationService: TranslationService,
    private readonly layoutConfigService: LayoutConfigService,
    private readonly authStoreService: AuthStoreService,
    private readonly permissionsService: NgxPermissionsService,
    private readonly splashScreenService: SplashScreenService,

    private readonly tokenStorageService: TokenStorageService) {

    // register translations
    this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);
    this.initialURL = window.location.pathname;
  }


  ngOnInit(): void {
    // set default timezone
    DateUtil.setDefaultTimeZone();

    // enable/disable loader
    this.loader = this.layoutConfigService.getConfig('loader.enabled');

    const routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('kt-page--loaded');
        }, 500);
      }
    });
    this.unsubscribe.push(routerSubscription);
    // this.setPermission();

  }
  /**
   * To send to the url when the page was refreshed
   */
  permissionRetrived() {
    setTimeout(() => {
      if (this.initialURL && this.initialURL.split('/') && this.initialURL.split('/').slice(1)) {
        this.router.navigate(this.initialURL.split('/').slice(1));
      }
    }, 2000);
  }

  /**
   * Gets called when page gets refresh to load the permission
   */
  // setPermission() {
  //   if (this.tokenStorageService.validateAccessToken() && this.tokenStorageService.validateBusinessToken()) {
  //     this.authStoreService.dispatchAuthCommon({
  //       module: AUTH_METHOD_CONSTANTS.PERMISSION,
  //       callback: this.permissionRetrived.bind(this),
  //     });
  //   }
  // }

  ngOnDestroy() {
    this.unsubscribe.forEach(sb => sb.unsubscribe());
  }
}
